// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ScheduleColumn[data-v-ff2f422c]{width:300px}.dragMeColumn[data-v-ff2f422c]{cursor:move}", ""]);
// Exports
module.exports = exports;
